export const PIE            = 'pie'
export const LINE           = 'line'
export const BAR            = 'bar'
export const DOUGHNUT       = 'doughnut'
export const RADAR          = 'radar'
export const POLAR          = 'polar'
export const BUBBLE         = 'bubble'
export const SCATTER        = 'scatter'
export const MIX            = 'mix'
export const HORIZONTALBAR  = 'horizontalbar'